import React, { useState, useEffect, useContext } from 'react';
import './styles.css';
import { Row, Col, Form, Button, Input, Checkbox, notification } from 'antd';
import { useSendMessage } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';
import { ModeBupContext } from '@BUP/contexts';

const SendMessageForm = () => {
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [error, setError] = useState(null);
  const { handleSendMessage } = useSendMessage();
  const [t] = useTranslation();
  // const [checkboxState, setCheckboxState] = useState(false);

  // const onChangeTerms = (e) => {
  //   setCheckboxState(e.target.checked);
  // };

  const { checkboxState, onChangeCheckBox } = useContext(ModeBupContext);

  useEffect(() => {
    forceUpdate({});
  }, []);

  const onSubmit = async (values) => {
    try {
      const comment = {
        content: values?.message || '',
        anonymus: values?.anonymous,
      };
      await handleSendMessage(comment);
      notification.info({
        style: { fontWeight: 500, fontSize: 17 },
        message: t(
          'pages.modeBup.send.sendMessageformComponent.notificationMessage'
        ),
        description: t(
          'pages.modeBup.send.sendMessageformComponent.notificationDescription'
        ),
        duration: 20,
      });
      setError(null);
      form.resetFields();
    } catch (e) {
      console.log('send message form', e);
      setError({
        message: t(
          'pages.modeBup.send.sendMessageformComponent.notificationErrorMessage'
        ),
      });
    }
  };

  return (
    <Col xs={24} lg={18} xxl={18} className="send-message-form-container">
      <h1>{t('pages.modeBup.send.sendMessageformComponent.formTitle')}</h1>
      <h2>{t('pages.modeBup.send.sendMessageformComponent.formText')}</h2>
      <Row style={{ marginTop: 20 }}>
        {error && error?.message ? (
          <Col xs={24} className="error-wrapper">
            <span>{error?.message}</span>
          </Col>
        ) : null}
        <Col xs={24} className="form-wrapper">
          <Form layout="vertical" form={form} onFinish={onSubmit}>
            <Form.Item
              name="message"
              rules={[
                {
                  required: true,
                  message: t(
                    'pages.modeBup.send.sendMessageformComponent.formTextMessage'
                  ),
                },
              ]}
            >
              <Input.TextArea
                size="large"
                placeholder={t(
                  'pages.modeBup.send.sendMessageformComponent.formPlaceholder'
                )}
                autoSize={{ minRows: 3 }}
              />
            </Form.Item>
            <Form.Item
              name="anonymous"
              valuePropName="checked"
              onChange={onChangeCheckBox}
              checked={checkboxState}
              initialValue={checkboxState}
            >
              <Checkbox
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                }}
              >
                {t(
                  'pages.modeBup.send.sendMessageformComponent.formCheckBoxText'
                )}
              </Checkbox>
            </Form.Item>
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  type="primary"
                  style={{ minWidth: 150, fontWeight: 'bold' }}
                  size="large"
                  htmlType="submit"
                  shape="round"
                  disabled={
                    form.getFieldsError().filter(({ errors }) => errors.length)
                      .length
                  }
                >
                  {t('pages.modeBup.send.sendMessageformComponent.formButton')}
                </Button>
              )}
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Col>
  );
};

export default SendMessageForm;
